import React, {useState} from "react"
import { Form, Row, Col, Button, Popover, OverlayTrigger } from "react-bootstrap"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

const CompoundChurnInput = (props) => {
  const [validated, setValidated] = useState(false)

  const {onSubmit} = props

  const currentMrrInfo = (
    <Popover>
      <Popover.Title as='h3'>Monthly Reccuring Revenue</Popover.Title>
      <Popover.Content>
        Your current monthly reccuring revenue. You can use <b>gross</b> or <b>net</b> numbers.<br/>If you are using <b>net</b> number, make sure that your monthly churn % also represents net churn.
      </Popover.Content>
    </Popover>
  )

  const mrrGrowthInfo = (
    <Popover>
      <Popover.Title as='h3'>MRR Growth</Popover.Title>
      <Popover.Content>
        By how much percent your MRR grew comparing to last month.<br />
        We assume constant growth for next 6 month to simplify the model.
      </Popover.Content>
    </Popover>
  )

  const currentMonthlyChurnInfo = (
    <Popover>
      <Popover.Title as='h3'>Monthly churn</Popover.Title>
      <Popover.Content>
        How much % of your MRR you are losing on monthly basis.
      </Popover.Content>
    </Popover>
  )

  const targetMonthlyChurnInfo = (
    <Popover>
      <Popover.Title as='h3'>Target monthly churn</Popover.Title>
      <Popover.Content>
        Desired monthly churn. We use this number to show you what improvement you could make by reducing your current churn.
      </Popover.Content>
    </Popover>
  )

  
  const handleSubmit = event => {
    const form = event.currentTarget

    event.preventDefault()
    event.stopPropagation()

    let validity = form.checkValidity()
    setValidated(true)
    if (validity === false) {
      return
    }

    const data = {
      startingMrr: parseInt(form.elements.startingMrr.value),
      mrrGrowth: parseInt(form.elements.mrrGrowth.value),
      currentChurn: parseFloat(form.elements.currentChurn.value),
      targetChurn: parseFloat(form.elements.targetChurn.value)
    }

    onSubmit(data)
  }

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Form.Group as={Row} controlId="churnForm.StartingMrr">
        <Form.Label column sm="8">
          Starting MRR
          <OverlayTrigger trigger='hover' placement='top' overlay={currentMrrInfo}>
            <FontAwesomeIcon icon={faInfoCircle} className='ml-1'/>
          </OverlayTrigger>
        </Form.Label>
        <Col sm="4">
          <Form.Control required name="startingMrr" type="numeric" placeholder="10000" defaultValue="300000"/>
          <Form.Control.Feedback type='invalid'>Enter your current MRR</Form.Control.Feedback>
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="churnForm.MrrGrowth">
        <Form.Label column sm="8">
          Month over month MRR growth %
          <OverlayTrigger trigger='hover' placement='top' overlay={mrrGrowthInfo}>
            <FontAwesomeIcon icon={faInfoCircle} className='ml-1'/>
          </OverlayTrigger>
        </Form.Label>
        <Col sm="4">
          <Form.Control required name="mrrGrowth" type="number" step='0.1' placeholder="10" defaultValue="10" />
          <Form.Control.Feedback type='invalid'>Month over month MRR growth. Percent. ex 3.4</Form.Control.Feedback>
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="churnForm.CurrentChurn">
        <Form.Label column sm="8">
          Current monthly churn %
          <OverlayTrigger trigger='hover' placement='top' overlay={currentMonthlyChurnInfo}>
            <FontAwesomeIcon icon={faInfoCircle} className='ml-1'/>
          </OverlayTrigger>
        </Form.Label>
        <Col sm="4">
          <Form.Control required name="currentChurn" type="number" min="0" max='100' step='0.1' placeholder="5" defaultValue="5"/>
          <Form.Control.Feedback type='invalid'>Current monthly churn. Percent. ex 5.8</Form.Control.Feedback>
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="churnForm.TargetedChurn">
        <Form.Label column sm="8">
          Target monthly churn %
          <OverlayTrigger trigger='hover' placement='top' overlay={targetMonthlyChurnInfo}>
            <FontAwesomeIcon icon={faInfoCircle} className='ml-1'/>
          </OverlayTrigger>
        </Form.Label>
        <Col sm="4">
          <Form.Control required name="targetChurn" type="number" min='0' max='100' step='0.1' placeholder="2.5" defaultValue="2.5"/>
          <Form.Control.Feedback type='invalid'>Monthly churn you are aiming for. Percent. ex 3.8</Form.Control.Feedback>
        </Col>
      </Form.Group>
      <Button variant="primary" type="submit">
        Calculate Impact
      </Button>
    </Form>
  )
}

export default CompoundChurnInput
